import useEntities from 'hooks/useEntities';
import RelationsEditable from 'components/RelationsEditable';

const PlayerSponsors = ({ data, sourceEntityId, onChange }) => {
    const entities = useEntities();

    return (
        <RelationsEditable
            data={data}
            sourceEntity={entities.Player} 
            targetEntity={entities.Sponsor}
            emptyMessage="This player does not have any sponsors"
            sourceEntityId={sourceEntityId}
            addButtonText="Add Sponsor"
            onChange={onChange}
        />
    )
}

export default PlayerSponsors
